import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** "/" and unknown paths: clients go to their audits, staff to the dashboard. */
function HomeRedirect() {
  const { user } = useAuth();
  return <Navigate to={user?.role_name === 'client' ? '/client' : '/dashboard'} replace />;
}

export default HomeRedirect;
